import SquareTable from './SquareTable';
export * from './SquareTable';

export default SquareTable;
